import * as React from "react";
import { makeStyles, Spinner } from "@fluentui/react-components";
import { FormSkeleton } from "../../components/FormSkeleton";
import { flexColumn, formStyle, fullSpace } from "../../styles/GlobalStyles";
import { RecordBaseData } from "../../components/RecordBaseData";
import { IDatabaseRecord } from "../../dto/IDatabaseRecord";
import { FluentDialog } from "../../components/FluentDialog";

export interface FormBaseProps
{
    id: string | undefined,
    record: IDatabaseRecord;
    isSaving: boolean;
    dialogs: React.ReactElement;
    toolbar: React.ReactElement;
    body: React.ReactElement;
    onSave: () => Promise<void>;
};

const useStyles = makeStyles({
    fullSpace: fullSpace,
    formRoot: {
        ...formStyle,
        height: "100%"
    },
    form: {
        ...formStyle,
        padding: "0rem clamp(1rem, 5vw, 4rem)",
        boxSizing: "border-box"
    },
    flexColumn: flexColumn,
    fixedToolbar: {
        position: "sticky",
        top: "0px",
        zIndex: 2,
        backgroundColor: "#333",
        marginLeft: "1rem",
        marginRight: "1rem"
    }
});

export const FormBase: React.FC<FormBaseProps> = React.memo(({ id, record, isSaving, dialogs, toolbar, body, onSave }) => {
    const styles = useStyles();

    const shortcutListener = React.useCallback(async (e: React.KeyboardEvent) =>
    {
        if (!e.repeat && e.key.toLowerCase() === "s" && e.ctrlKey)
        {
            e.preventDefault();
            await onSave();
        }
    }, [onSave]);

    return (
        <div id="formRoot" className={styles.formRoot} onKeyDown={shortcutListener}>
            <FluentDialog title="Saving..." open={isSaving} noActions={true}>
                <div className={styles.form}>
                    <Spinner />
                </div>
            </FluentDialog>

            { dialogs }

            <div className={styles.fixedToolbar}>
                { toolbar }
            </div>

            <div className={styles.form}>
                { ( id && id !== "new" ) && ( !record.guid || id !== record.guid )
                    ? <FormSkeleton />
                    : (
                        <div className={styles.flexColumn}>
                            { body }
                        </div>
                    )
                }
            </div>

            <RecordBaseData record={record} />
        </div>
    );    
});